import React, { memo } from 'react';
import { Input } from 'js/components/common/Fields/Input';

import * as Types from './types';

export const IBANFieldBare: React.FC<Types.IIBANFieldProps> = ({
    id,
    name,
    label,
    validate,
    disabled,
    readOnly,
    className,
    ariaLabel,
    placeholder,
    infoTooltip,
    isLabelAsteriskEnabled,
    isPlaceholderAsteriskEnabled
}) => (
    <Input
        id={id}
        name={name}
        type="text"
        label={label}
        inputMode="numeric"
        disabled={disabled}
        className={className}
        aria-label={ariaLabel}
        placeholder={placeholder}
        infoTooltip={infoTooltip}
        isLabelAsteriskEnabled={isLabelAsteriskEnabled}
        isPlaceholderAsteriskEnabled={isPlaceholderAsteriskEnabled}
        {...readOnly && { readOnly: true }}
        {...validate && { validate }}
    />
);

export const IBANField = memo(IBANFieldBare);
